import { v4 as uuid } from "uuid";

export const tableHeaders = [
  // { value: "checkbox", width: 50, isSorted: false, isHandle: false, id: uuid(), isHideInRightsTable: true },
  { text: "Код", width: 250, value: "code", isLink: true, isSorted: true, isHandle: true, id: uuid() },
  { text: "Значение", width: 400, value: "name", isLink: false, isSorted: false, isHandle: true, id: uuid() },
  { text: "Описание", width: 400, value: "description", isLink: false, isSorted: false, isHandle: true, id: uuid() },
];
